import type { FC } from 'react'

import { Button } from '@/components/DEPRECATED_UI/Button'
import H3 from '@/components/H3'
import LoadingSpinner from '@/components/LoadingSpinner'
import { useRunCreditCheckMutation } from '@/lib/apollo'

interface Props {
  customerId: string
  subjectId: string
}

const RerunCreditChecks: FC<Props> = ({ customerId, subjectId }) => {
  const [handleRerunCreditChecks, { loading, error }] = useRunCreditCheckMutation()

  return (
    <div>
      <H3>Credit checks</H3>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {error?.message && <div>An unexpected error occurred. {error?.message}</div>}
          <Button
            disabled={loading}
            onClick={() =>
              handleRerunCreditChecks({
                variables: {
                  customerId,
                  subjectId,
                },
              })
            }
          >
            Rerun credit checks
          </Button>
        </>
      )}
    </div>
  )
}

export default RerunCreditChecks
